<template>
  <div style="margin-right: 15px">
    <b-link
        class="upload-btn"
        @click="handleOpenSidebar"
        :disabled="disabled"
        style="background-color: transparent "
    >
      <b-icon
          v-if="sidebarIcon"
          :icon="sidebarIcon"
          font-scale="1.25"
          style="margin-right: 5px"
      />
      <h5 style="margin-top: 10px">
        {{ sidebarTitle }}
      </h5>
    </b-link>
    <b-sidebar
        :ref="sidebarUniqueId"
        :id="sidebarUniqueId"
        :title="sidebarTitle"
        :width="width"
        :right="right"
        :backdrop-variant="backdropVariant"
        :backdrop="backdrop"
        :shadow="shadow"
        :no-header="noHeader"
        centered
        @change="handleSidebarChange"
    >
      <template #title>
          <h2>{{ sidebarTitle }}</h2>
      </template>
      <template #header-close>
        <close-button
            @close-button-click="handleCloseSideBar"
        />
      </template>
      <sidebar-session
          v-if="sidebarType === 'sessions-sidebar'"
          :session="session"
          :profile="profile"
          :theme="theme"
          @add-data-click="handleAddDataButtonClick"
      />
      <sidebar-session-google
          v-else-if="sidebarType === 'sessions-sidebar-google'"
          :session="session"
          :profile="profile"
          :theme="theme"
          @add-data-click="handleAddDataButtonClick"
      />
      <sidebar-registration
          v-else-if="sidebarType === 'registration-sidebar'"
          :session="session"
          :profile="profile"
          :theme="theme"
      />
      <sidebar-notification-customization
          v-else-if="sidebarType === 'notification-sidebar'"
          :session="session"
          :profile="profile"
          :theme="theme"
      />
      <div  v-else>
        <h2>SideBar Does Not Exist</h2>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CloseButton from "@/components/common/closeButton";
import SidebarSession from "@/components/common/sessionComponents/sessions/sessionStandard";
import SidebarSessionGoogle from "@/components/common/sessionComponents/sessions/sessionGoogle";
import SidebarRegistration from "@/components/common/sessionComponents/sessions/registrationStandard";
import SidebarNotificationCustomization from "@/components/common/sessionComponents/sessions/notificationCustomization";
export default {
  name: "Sessions_Sidebar",
  components: {
    CloseButton,
    SidebarSession,
    SidebarSessionGoogle,
    SidebarRegistration,
    SidebarNotificationCustomization
  },
  props: {
    sidebarType: {
      type: String,
      default: "sessions-sidebar"
    },
    sidebarId: {
      type: Number,
      default: "sessions-sidebar"
    },
    sidebarTitle: {
      type: String,
      default: "Sessions"
    },
    sidebarIcon: {
      type: String,
      default: null
    },
    profile: {
      type: Object,
      default: () => {}
    },
    session: {
      type: Object,
      default: () => {}
    },
    noHeader: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: "90%"
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  mounted() {},
  computed: {
    ...mapGetters({ }),
    theme(){
      return this.themeOpts && this.themeOpts[this.themeSelection] ? this.themeOpts[this.themeSelection] :
          this.themeOpts['default'];
    }
  },
  methods: {
    handleOpenSidebar() {
      this.$root.$emit('bv::toggle::collapse', this.sidebarUniqueId);
    },
    handleSidebarChange() {

    },
    handleCloseSideBar() {
      this.$root.$emit('bv::toggle::collapse', this.sidebarUniqueId);
    },
    handleAddDataButtonClick(session) {
      this.$emit('add-data-click', session);
    }
  },
  data() {
    return {
      sidebarUniqueId:`${this.sidebarType}-${this.sidebarId}`,
      right: true,
      shadow: true,
      backdrop: true,
      backdropVariant: 'dark',
      themeOpts: {
        default: {
          name: "Purple Haze",
          date: 12345,
          main: {
            bgColor: '6118a8',
            bgImg: '',
            textColor: 'ffffff',
          },
          panelChat: {
            bgColor: '6118a8',
            textColor: 'ffffff',
          },
          panelScreen: {
            bgColor: '6118a8',
            textColor: 'ffffff',
          }
        },
        purple_haze: {
          name: "Purple Haze",
          date: 12345,
          theme: {
            main: {
              bgColor: '6118a8',
              bgImg: '',
              textColor: 'ffffff',
            },
            panelChat: {
              bgColor: '6118a8',
              textColor: 'ffffff',
            },
            panelScreen: {
              bgColor: '6118a8',
              textColor: 'ffffff',
            }
          },
        },
        blue_sea: {
          name: "Purple Haze",
          date: 12345,
          main: {
            bgColor: '6118a8',
            bgImg: '',
            textColor: 'ffffff',
          },
          panelChat: {
            bgColor: '6118a8',
            textColor: 'ffffff',
          },
          panelScreen: {
            bgColor: '6118a8',
            textColor: 'ffffff',
          }
        },
      },
      themeSelection:'purple_haze'
    };
  }
};
</script>

<style lang="scss" scoped>
.upload-btn {
  cursor: pointer;
  background-color: #fff;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  max-width: 220px;
  height: 50px;
  border: none;
  letter-spacing: 0.05em;
  align-items: center;
  color: var(--theme-color);
  margin-left: 16px;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  .content {
    display: flex;
    #blogger-publishing-video {
      width: 0;
    }
    #guide-publishing-image {
      width: 0;
    }
    .ico {
      margin-right: 3px;
      img {
        cursor: pointer;
        position: relative;
        top: 50%;
        right: 4px;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        height: 24px;
        width: 24px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        background: rgba(85, 126, 251, 0.1);
        border-radius: 8px;
      }
      svg {
        height: 30px;
      }
    }
    .watch-video {
      margin-top: 5px;
    }
    .btn-content {
      margin-top: 2px;
      font-family: Nunito;
      font-style: normal;
      font-size: 16px;
      line-height: 22px;
      color: var(--theme-color);
    }
  }
}
.upload-btn:focus {
  outline: none;
  box-shadow: none;
}
</style>
